module.exports = __webpack_public_path__ + "static/urszula_augustyniak-452878e859bdfef0e461702608da62e0.png";